import { valueEqualsOption } from '../util';

describe('SelectList', () => {
  describe('valueEqualsOption', () => {
    it('should return true if given string value matches given string option', () => {
      expect(valueEqualsOption({ option: 'foo', value: "foo" })).toBe(true);
    })

    it('should return false if given string value does not matches string option', () => {
      expect(valueEqualsOption({ option: 'foo', value: "bar" })).toBe(false);
    })

    it('should return true if given string value matches object option', () => {
      expect(valueEqualsOption({
        option: { label: 'Foo', value: 'foo' },
        value: 'foo',
        valueKey: 'value'
      })).toBe(true);
    })

    it('should return false if given string value does not match object option', () => {
      expect(valueEqualsOption({
        option: { label: 'Foo', value: 'foo' },
        value: 'bar',
        valueKey: 'value'
      })).toBe(false);
    })

    it('should return true if given object value mathes given object option', () => {
      expect(valueEqualsOption({
        option: { label: 'Foo', value: 'foo' },
        value: { label: 'Foo', value: 'foo' },
        valueKey: 'value'
      })).toBe(true);
    })

    it('should return false if given object value does not match given object option', () => {
      expect(valueEqualsOption({
        option: { label: 'Foo', value: 'foo' },
        value: { label: 'Bar', value: 'bar' },
        valueKey: 'value'
      })).toBe(false);
    })
  })

})
